import { esc } from '@/utils/escape';

export function generateBenefitsHTML(data: any, settings: any): string {
  const itemsArray = data.items || [];
  const itemCount = itemsArray.length;

  // Grid-Klasse basierend auf Item-Anzahl
  const gridClass =
    itemCount === 3
      ? "benefits__grid benefits__grid--three"
      : "benefits__grid";

  const items = itemsArray
    .map(
      (item: any) => `        <div class="benefit">
          <div class="benefit__icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <div>
            <h4>${esc(item.title)}</h4>
            <p>${esc(item.text)}</p>
          </div>
        </div>`,
    )
    .join("\n");

  return `  <!-- Benefits -->
  <section class="benefits" id="vorteile">
    <div class="container">
      <div class="section-header">
        <h2>${esc(data.title)}</h2>
        ${data.subtitle ? `<p>${esc(data.subtitle)}</p>` : ""}
      </div>
      <div class="${gridClass}">
${items}
      </div>
    </div>
  </section>`;
}
